import { render, staticRenderFns } from "./InfoPanelDashboard.vue?vue&type=template&id=26b7b68b&scoped=true"
import script from "./InfoPanelDashboard.vue?vue&type=script&lang=ts"
export * from "./InfoPanelDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b7b68b",
  null
  
)

export default component.exports